// import "@aws-amplify/ui/dist/style.css";
// import { UsernameAttributes } from "aws-amplify-react";

/**
 * You can create your own theme and use it to render Amplify components
 * Your custom theme must use the selectors from the following
 * template: https://github.com/aws-amplify/amplify-js/blob/master/packages/aws-amplify-react/src/Amplify-UI/Amplify-UI-Theme.tsx
 */
const amplifyTheme = {};

export const appSyncSettings = {
  aws_appsync_graphqlEndpoint:
    process.env.REACT_APP_PUBLIC_GRAPHQL_API_ENDPOINT_URL,
  aws_appsync_region:
    process.env.REACT_APP_PUBLIC_GRAPHQL_API_REGION ?? "ap-southeast-2",
  aws_appsync_authenticationType:
    process.env.REACT_APP_PUBLIC_GRAPHQL_AUTH_TYPE ?? "AWS_IAM",
};

// **
// * This object is used by Config.getInstance().init()
// * or Amplify.configure() method.
// * To add more fields check the following link: https://aws-amplify.github.io/docs/js/authentication#manual-setup
// */
export const amplifyConfig = {
  Auth: {
    identityPoolId:
      process.env.REACT_APP_IDENTITY_POOL_ID ||
      "ap-southeast-2:59eddaa2-cbeb-4e90-a1b3-9d29a0566f67",
    region: process.env.REACT_APP_REGION || "ap-southeast-2",
    userPoolId:
      process.env.REACT_APP_USER_POOL_ID || "ap-southeast-2_YD1CjliKc",
    userPoolWebClientId:
      process.env.REACT_APP_USER_POOL_WEBCLIENT_ID ||
      "2idktgnh3etakobvfrpn9k5vlq",
    mandatorySignIn: true,
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
  API: {
    endpoints: [
      {
        name: "TEST_BASE_URL",
        endpoint:
          "https://3ddb1a2ycb.execute-api.ap-southeast-2.amazonaws.com/",
        region: "ap-southeast-2",
      },
    ],
  },
  language: "us",
  amplifyEnv: process.env.REACT_APP_AMPLIFY_ENV,
};

/**
 * Used by Authenticator component as configuration
 */
export const authenticatorConfig = {
  theme: amplifyTheme,
  hideSignUp: true,
};
